(() => {
  const canHover = window.matchMedia('(hover: hover)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const STEP_MS = 1000;
  const state = new WeakMap();

  const build = (card) => {
    const link = card.querySelector('.gk-product__imglink');
    const sources = (card.dataset.gkImages || '').split('|').filter(Boolean);
    const first = link && link.querySelector('img');
    if (!first || sources.length === 0) return null;

    const slides = [first];
    sources.forEach((src) => {
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.decoding = 'async';
      slides.push(img);
      link.appendChild(img);
    });

    const dots = document.createElement('span');
    dots.className = 'gk-product__dots';
    dots.setAttribute('aria-hidden', 'true');
    slides.forEach(() => dots.appendChild(document.createElement('i')));
    card.appendChild(dots);

    return { slides, dots: [...dots.children], index: 0, timer: null };
  };

  const show = (info, index) => {
    info.index = index;
    info.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    info.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  };

  const start = (card) => {
    if (!canHover.matches || reduceMotion.matches) return;
    let info = state.get(card);
    if (info === undefined) {
      info = build(card);
      state.set(card, info);
    }
    if (!info || info.timer) return;
    info.dots[0].classList.add('is-active');
    card.classList.add('is-cycling');
    info.timer = setInterval(() => show(info, (info.index + 1) % info.slides.length), STEP_MS);
    setTimeout(() => {
      if (info.timer && info.index === 0) show(info, 1);
    }, 350);
  };

  const stop = (card) => {
    const info = state.get(card);
    card.classList.remove('is-cycling');
    if (!info) return;
    clearInterval(info.timer);
    info.timer = null;
    show(info, 0);
  };

  document.addEventListener('mouseover', (event) => {
    const card = event.target.closest && event.target.closest('.gk-product__image');
    if (card && !card.contains(event.relatedTarget)) start(card);
  });

  document.addEventListener('mouseout', (event) => {
    const card = event.target.closest && event.target.closest('.gk-product__image');
    if (card && !card.contains(event.relatedTarget)) stop(card);
  });

  // Wishlist count on the header heart, kept in sync with the theme's wishlist events.
  const updateWishlistBadge = () => {
    const link = document.querySelector('.gk-actions__wishlist');
    if (!link) return;
    let total = 0;
    try {
      const list = JSON.parse(localStorage.getItem('wishlistItem'));
      total = Array.isArray(list) ? list.length : 0;
    } catch (error) {
      total = 0;
    }
    let badge = link.querySelector('[data-gk-wishlist-badge]');
    if (!badge && total > 0) {
      badge = document.createElement('b');
      badge.setAttribute('data-gk-wishlist-badge', '');
      link.appendChild(badge);
    }
    if (badge) {
      badge.textContent = total;
      badge.hidden = total === 0;
    }
  };

  updateWishlistBadge();
  document.addEventListener('add:wishlist-item', updateWishlistBadge);
  document.addEventListener('remove:wishlist-item', updateWishlistBadge);
  window.addEventListener('storage', updateWishlistBadge);
})();
